// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2FbFx","productName":"Table_productName__useuv"};